import { TimelineMax, Expo } from 'gsap';

export default function text(el) {
  const tl = new TimelineMax({
    paused: true,
  });

  const lines = Array.from(el.querySelectorAll('.line'));
  const em = [...Array.from(el.querySelectorAll('em')), ...Array.from(el.querySelectorAll('i'))];

  // tl
  //   .addLabel('start')
  //   .staggerTo(lines, 1.6, {
  //     autoAlpha: 1,
  //     y: 0,
  //     scaleY: 1,
  //     ease: Expo.easeOut,
  //   }, 0.1, 'start');

  tl
    .addLabel('start')
    .to(el, 1, {
      y: 0,
      ease: Power2.easeOut,
    }, 'start')
    .staggerTo(lines, 1, {
      x: 0,
      y: 0,
      rotationX: 0,
      autoAlpha: 1,
      ease: Power2.easeOut,
    }, 0.1, 'start')
    .to(em, 1, {
      backgroundImage: 'linear-gradient(to right, #474752 100%, #F2F2F2 0%)',
      ease: Power2.easeOut,
    }, 'start+=0.75');

  return tl;
}
